module.exports = __webpack_public_path__ + "static/media/addyPost.ed82a045.jpg";